import React, { useEffect } from 'react';
import Layout from '../components/Layout';
import { Card, CardContent } from "../components/ui/card";

const AboutFR = () => {
  useEffect(() => {
    document.title = 'Internjin | À Propos';
  }, []);

  return (
    <Layout>
      <section className="py-20 bg-slate-50">
        <div className="container mx-auto px-4 md:px-6 max-w-4xl">
          <div className="text-center mb-16">
            <h1 className="text-4xl font-bold text-slate-900 mb-6">À Propos d'Internjin</h1>
            <p className="text-xl text-slate-600 max-w-2xl mx-auto">
              Nous construisons le pont ultime entre les talents européens et l'innovation japonaise.
            </p>
          </div>

          <div className="prose prose-slate max-w-none mb-20">
            <h2 className="text-2xl font-bold text-slate-900 mb-4">Notre Mission</h2>
            <p className="text-slate-600 mb-8">
              Internjin est né d'un constat simple : le Japon fait face à une pénurie critique de talents, tandis que les étudiants français sont avides d'expérience internationale mais manquent souvent d'accès au marché japonais. Nous existons pour résoudre ces deux problèmes simultanément en créant une voie rationalisée et accompagnée vers des stages d'élite.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <Card className="border-none shadow-lg bg-white">
              <CardContent className="p-8 flex flex-col items-center text-center">
                <div className="h-24 w-24 bg-slate-200 rounded-full flex items-center justify-center mb-6 text-2xl font-bold text-slate-600">
                  PT
                </div>
                <h3 className="text-2xl font-bold text-slate-900 mb-1">P. Theotime</h3>
                <p className="text-red-600 font-medium mb-6">Co-Fondateur</p>
                <div className="text-slate-600 text-sm space-y-2">
                  <p>Master en Robotique (CPE Lyon)</p>
                  <p>Ex-Stagiaire chez BMW Japon (Tokyo)</p>
                </div>
              </CardContent>
            </Card>

            <Card className="border-none shadow-lg bg-white">
              <CardContent className="p-8 flex flex-col items-center text-center">
                <div className="h-24 w-24 bg-slate-200 rounded-full flex items-center justify-center mb-6 text-2xl font-bold text-slate-600">
                  DC
                </div>
                <h3 className="text-2xl font-bold text-slate-900 mb-1">D. Chahan</h3>
                <p className="text-red-600 font-medium mb-6">Co-Fondateur</p>
                <div className="text-slate-600 text-sm space-y-2">
                  <p>Master en Robotique (CPE Lyon)</p>
                  <p>Ex-Stagiaire chez Sound & Vision (Osaka)</p>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default AboutFR;
